// extracted by mini-css-extract-plugin
module.exports = {"vUiHue":"#ddd","wrapper":"styles__wrapper___ZzSvI","separator":"styles__separator___Ypy50"};